import { CloseIcon } from '../Icons/close';
import { HamburgerIcon } from '../Icons/hamburger';

interface IProps {
  handleMenuClick: () => void;
  isOpen: boolean;
}
const HamburgerMenu = ({
  handleMenuClick,
  isOpen = false,
}: IProps): JSX.Element => (
  <div className=" inline-flex  rounded md:hidden lg:hidden xl:hidden text-grey-850 ml-auto ">
    <button
      className="hover:text-white"
      data-testid="hamburger-menu-button"
      onClick={() => handleMenuClick()}
    >
      {isOpen ? <CloseIcon /> : <HamburgerIcon />}
    </button>
  </div>
);

export { HamburgerMenu };
